import React, { useState } from 'react'
import { TileGroup, RadioTile } from 'carbon-components-react';
import * as DashboardConstants from './DashboardConstants';
require("./_lens.scss");

const Lens = (props) => {
    return (
        <div className='lens-section'>
            <TileGroup defaultSelected={props.selectedKpi}>
                <RadioTile tabIndex={0} value="Hours saved" onClick={(e) => props.handleItemClick(DashboardConstants.ROI)}>
                    {DashboardConstants.ROI}
                </RadioTile>
                <RadioTile tabIndex={0} value="Success rate" onClick={(e) => props.handleItemClick(DashboardConstants.successrate)}>
                    {DashboardConstants.successrate}
                </RadioTile>
                <RadioTile tabIndex={0} value="Termination rate" onClick={(e) => props.handleItemClick(DashboardConstants.Terminationrate)}>
                    {DashboardConstants.Terminationrate}
                </RadioTile>
                <RadioTile tabIndex={0} value="Capacity utilization" onClick={(e) => props.handleItemClick(DashboardConstants.CapacityUtilization)}>
                    {DashboardConstants.CapacityUtilization}
                </RadioTile>
                {/* <RadioTile tabIndex={0} value="SelfHealRate" onClick={(e) => handleItemClick(DashboardConstants.SelfHealRate)}>
                            {DashboardConstants.SelfHealRate}
                        </RadioTile> */}
            </TileGroup>
        </div>
    );
};

export default Lens;